import { Chip, Stack, Typography } from "@braintrust/braintrust-ui-components";
import { RefreshIcon } from "@braintrust/braintrust-ui-components/Icons";
import type { EmployerBidListBid, Job } from "@js/types/jobs";

type ExternalIntegrationStatusChipProps = {
  bid: Pick<EmployerBidListBid, "external_status">;
  job: Pick<Job, "integration_label">;
};

export const ExternalIntegrationStatusChip = ({
  bid,
  job,
}: ExternalIntegrationStatusChipProps) => {
  const { external_status: status } = bid;
  const { integration_label: label } = job;
  if (!label || !status) {
    return <></>;
  }
  return (
    <Chip
      size="x-small"
      color="beige"
      sx={{ maxWidth: "100%" }}
      label={
        <Stack
          direction="row"
          sx={{ gap: 0.5, color: "var(--black)", alignItems: "center" }}
        >
          <RefreshIcon sx={{ fontSize: "1rem" }} />
          <Stack
            sx={{ flexWrap: "wrap", flexDirection: "row", columnGap: 0.25 }}
          >
            <Typography component="span" size="small">
              {label} status:
            </Typography>
            <Typography component="span" size="small" fontWeight={500}>
              {status}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
